import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { StyledButton } from '../styles/StyledButtons';

interface PlaceholderContactReplaceDialogProps {
  open: boolean;
  submitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PlaceholderContactReplaceDialog: React.FC<PlaceholderContactReplaceDialogProps> = ({
  open,
  submitting,
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Replacement</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to replace this placeholder contact with the selected contact? This
        action cannot be undone.
      </Typography>
    </DialogContent>
    <DialogActions>
      <StyledButton onClick={onClose} disabled={submitting}>
        Cancel
      </StyledButton>
      <StyledButton variant="contained" onClick={onConfirm} disabled={submitting}>
        {submitting ? 'Replacing...' : 'Replace'}
      </StyledButton>
    </DialogActions>
  </Dialog>
);

export default PlaceholderContactReplaceDialog;
